module.exports = __webpack_public_path__ + "app/components/messages/create-text-v2.view.html";